import { RELATION_LIST, RELATION_ADDEDIT, RELATION_CHANGE_STATUS, RELATION_DELETE } from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const relationListApi = (payload) => {
    return apiInstance.post(RELATION_LIST, payload, {
        headers: authHeader(),
    });
};

export const relationChangeStatusApi = (payload) => {
    return apiInstance.post(RELATION_CHANGE_STATUS, payload, {
        headers: authHeader(),
    });
};

export const relationDeleteApi = (payload) => {
    return apiInstance.post(RELATION_DELETE, payload, {
        headers: authHeader(),
    });
};

export const AddEditRelationApi = (payload) => {
    return apiInstance.post(RELATION_ADDEDIT, payload, {
        headers: authHeader(),
    });
};